/** Default institute logo (override with `window.LP_LOGO_URL` when embedding). */
export const DEFAULT_INSTITUTE_LOGO_URL =
  "https://gcsewithrosi.co.uk/wp-content/uploads/2024/09/cropped-DALL%C2%B7E-2024-09-25-23.04.37-A-simple-and-child-friendly-logo-for-GCSE-WITH-ROSI_-featuring-a-light-bulb-on-top-of-an-open-book.-The-title-GCSE-WITH-ROSI-should-be-prominently-1.jpg";

export const INSTITUTE_NAME = "GCSE with Rosi";

export function getInstituteLogoUrl(): string {
  if (typeof window !== "undefined" && window.LP_LOGO_URL?.trim()) {
    return window.LP_LOGO_URL.trim();
  }
  return DEFAULT_INSTITUTE_LOGO_URL;
}
